module.exports = __webpack_public_path__ + "static/jeff-williams-5482301df3f2bf0bb887290023afa974.jpg";